import {assert} from 'assert-ts';
import type {ThesaurusAction} from 'types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import type {ThesaurusNode, ThesaurusValue} from 'services/thesaurus/types';
import {useSceneExtensionContext} from 'sceneExtensions/contexts';
import type {ThesaurusFieldConfig} from '../types';

export const useThesaurusEditContext = () => {
  const extension = useSceneExtensionContext<
    FieldExtensionEnum.thesaurusEdit,
    ThesaurusValue,
    ThesaurusValue,
    ThesaurusAction,
    ThesaurusFieldConfig,
    ThesaurusNode
  >(FieldExtensionEnum.thesaurusEdit);
  return assert(extension).fieldContext;
};
